import { connect } from 'react-redux';
import { setSubmitted, setTermsAccepted } from 'redux/modules/invoice/index';
import Footer from './footer';

function mapStateToProps (state) {
  return {
    invoiceId: state.invoice.invoiceId,
    submitted: state.invoice.submitted,
    termsAccepted: state.invoice.termsAccepted,
    valid: state.invoice.valid,
    posting: state.invoice.posting,
    postError: state.invoice.postError,
    validationErrors: state.validationError,
    invoice: state.invoice
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubmitted: (submitted) => dispatch(setSubmitted(submitted)),
    setTermsAccepted: (termsAccepted) => dispatch(setTermsAccepted(termsAccepted))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/footer/footer-container.js
 **/